import React from 'react'
import PropTypes from 'prop-types'
import VideoBlockStyles from '../css/components/video-block'

export default function VideoBlock({ section }) {
  if (!section.video_id || !section.cover_image) return null
  const coverImage = section.cover_image.formats.large
    ? section.cover_image.formats.large.url
    : section.cover_image.formats.medium.url

  return (
    <>
      <style>
        {VideoBlockStyles}
      </style>

      <div className="diesel-tracks__video-block video-item">
        <div className="diesel-tracks__video-block-wrapper">
          <div
            id="VideoBlockCover"
            className="diesel-tracks__video-block-cover"
            style={{ backgroundImage: `url(${coverImage})` }}>
            {section.diesel_logo &&
              <img
                className="diesel-tracks__hero-diesel-logo"
                src={section.diesel_logo.url}
                alt="Diesel Logo" />
            }

            <div className="diesel-tracks__video-block-contents">
              <div>
                {section.diesel_tracks_logo &&
                  <img
                    className="diesel-tracks__hero-diesel-tracks-logo"
                    src={section.diesel_tracks_logo.url}
                    alt="Diesel Tracks Logo" />
                }

                {section.heading &&
                  <h1 className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__hero-heading">
                    {section.heading}
                  </h1>
                }

                {section.video_id &&
                  <>
                    <div
                      id="VideoBlockLoading"
                      className="diesel-tracks__video-block-loading">
                      <svg
                        width="200"
                        height="200"
                        viewBox="0 0 200 200"
                        color="#fff"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <defs>
                          <linearGradient id="spinner-secondHalf">
                            <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
                            <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
                          </linearGradient>
                          <linearGradient id="spinner-firstHalf">
                            <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
                            <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
                          </linearGradient>
                        </defs>

                        <g strokeWidth="8">
                          <path stroke="url(#spinner-secondHalf)" d="M 4 100 A 96 96 0 0 1 196 100" />
                          <path stroke="url(#spinner-firstHalf)" d="M 196 100 A 96 96 0 0 1 4 100" />
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            d="M 4 100 A 96 96 0 0 1 4 98"
                          />
                        </g>

                        <animateTransform
                          from="0 0 0"
                          to="360 0 0"
                          attributeName="transform"
                          type="rotate"
                          repeatCount="indefinite"
                          dur="1300ms"
                        />
                      </svg>
                    </div>
                    <button
                      id="VideoBlockPlayButton"
                      className="visuallyhidden diesel-tracks__video-block-play-button"
                      aria-label="Video Play Button">
                      <div className="diesel-tracks__video-block-play-icon-container">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 42">
                          <g clipPath="url(#a)">
                            <path d="M42 42H0V.002h42V42ZM15.912 12.398a.277.277 0 0 0-.162.053.415.415 0 0 0-.136.172.438.438 0 0 0-.033.222v16.314a.42.42 0 0 0 .029.224.4.4 0 0 0 .14.172.281.281 0 0 0 .158.047.502.502 0 0 0 .256-.083l14.01-8.177a.386.386 0 0 0 .167-.13.413.413 0 0 0 .078-.204c0-.131-.083-.245-.245-.34l-14.01-8.178a.466.466 0 0 0-.25-.091h-.002Z" />
                          </g>
                          <defs>
                            <clipPath>
                              <path d="M0 0h42.001v42H0z"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      {section.cta_button_label &&
                        <span className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__video-block-play-label">
                          {section.cta_button_label}
                        </span>
                      }
                    </button>
                  </>
                }
              </div>
            </div>
          </div>

          {section.video_id &&
            <div className="diesel-tracks__video-block-player">
              <div className="diesel-tracks__video-block-player-wrapper">
                <div
                  id={`DieselTracksVideoPlayer${section.strapi_component}-${section.id}`}
                  className="diesel-tracks__video-block-player"
                  data-youtubeid={section.video_id} />
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

VideoBlock.propTypes = {
  section: PropTypes.object,
}
